// extracted by mini-css-extract-plugin
module.exports = {"box":"HmGameHorizontal_box_3IWQK","game-list":"HmGameHorizontal_game-list_1gwOJ"};